export const banks = [
    { label: '경남은행', code: '039' },
    { label: '광주은행', code: '034' },
    { label: '교보증권', code: '261' },
    { label: '단위농협(지역농축협)', code: '012' },
    { label: '대신증권', code: '267' },
    { label: '메리츠증권', code: '287' },
    { label: '미래에셋증권', code: '238' },
    { label: '부국증권', code: '290' },
    { label: '부산은행', code: '032' },
    { label: '삼성증권', code: '240' },
    { label: '새마을금고', code: '045' },
    { label: '산림조합', code: '064' },
    { label: '신영증권', code: '291' },
    { label: '신한금융투자', code: '278' },
    { label: '신한은행', code: '088' },
    { label: '신협', code: '048' },
    { label: '씨티은행', code: '027' },
    { label: '우리은행', code: '020' },
    { label: '우체국예금보험', code: '071' },
    { label: '유안타증권', code: '209' },
    { label: '유진투자증권', code: '280' },
    { label: '저축은행중앙회', code: '050' },
    { label: '전북은행', code: '037' },
    { label: '제주은행', code: '035' },
    { label: '카카오뱅크', code: '090' },
    { label: '카카오페이증권', code: '288' },
    { label: '케이뱅크', code: '089' },
    { label: '토스뱅크', code: '092' },
    { label: '토스증권', code: '271' },
    { label: '펀드온라인코리아(한국포스증권)', code: '294' },
    { label: '하나금융투자', code: '270' },
    { label: '하나은행', code: '081' },
    { label: '하이투자증권', code: '262' },
    { label: '한국투자증권', code: '243' },
    { label: '한화투자증권', code: '269' },
    { label: '현대차증권', code: '263' },
    { label: '홍콩상하이은행', code: '054' },
    { label: 'DB금융투자', code: '279' },
    { label: 'DGB대구은행', code: '031' },
    { label: 'IBK기업은행', code: '003' },
    { label: 'KB국민은행', code: '004' },
    { label: 'KB증권', code: '218' },
    { label: 'KDB산업은행', code: '002' },
    { label: 'KTB투자증권(다올투자증권)', code: '227' },
    { label: 'LIG투자증권', code: '292' },
    { label: 'NH농협은행', code: '011' },
    { label: 'NH투자증권', code: '247' },
    { label: 'SC제일은행', code: '023' },
    { label: 'SH수협은행', code: '007' },
    { label: 'SK증권', code: '266' },
]